import TableButton from "components/atoms/buttons/TableButton";
import Type from "components/atoms/text/labels/Type";
import HealthPresenter from "./HealthPresenter";
import {
  RecorderHealthRow,
  ReportHealthList,
} from "api/interfaces/reportInterface.interface";
import { ReportDataRow } from "api/interfaces/reportInterface.interface";
import * as s from "./HealthStyled";
import { checkStatus, convertType, formatNumber } from "utils/functions";
import TableTitle from "components/blocks/table/TableTitle";
import { useLocation, useParams } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import {
  BasePagination,
  LEVEL_TYPE,
  SORT_DIRECTION,
} from "api/interfaces/commonInterface.interface";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { getHealthReportList } from "api/reportAPI";
import { useQuery } from "react-query";
// import { healthTableData } from "pages/reports/tempData";
import WebAppLink from "components/blocks/link/WebAppLink";
import { isNull } from "lodash";

import { TableColumnsType } from "antd";
import {
  changeSortOrderAntd,
  onSortAntd,
} from "components/atoms/table/AntdTable";
import { ColumnType } from "antd/es/table";
import NoAvailable from "components/templates/nopage/NoAvailable";
import { useMenu } from "hook/useMenu";
import AccountInfoLabel from "components/atoms/text/labels/AccountInfoLabel";
import { baseQueryInfo, useQueryKey } from "utils/queryUtil";
import * as mediaQuery from "components/MediaQuery";
import { ExpandableConfig } from "antd/es/table/interface";
import HealthExpandContainer from "./HealthExpandContainer";
import useStompDebouncedRefetch, {
  StompDateSignalKey,
} from "hook/useStompDebouncedRefetch";

type Props = {
  state: ReportDataRow;
};

interface AlertTotalCount {
  [key: string]: number;
}

export interface AlertDetail {
  system: number;
  disk: number;
  video: number;
  cloudStatus: boolean;
}

const initialReportQueryInfo = {
  ...baseQueryInfo,
  sortType: "name",
};

export default function HealthContainer(props: Props): JSX.Element {
  const location = useLocation();

  const params = useParams();
  const { queryNavigate, menuNavigation } = useMenu({});
  const isMobile = mediaQuery.useIsMobile();

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const reportId = params.reportId as string;

  const [reportQueryInfo, setReportQueryInfo] = useState<BasePagination>({
    ...initialReportQueryInfo,
  });
  const reportQueryKey = useQueryKey(reportQueryInfo);

  const [reportMergedQueryInfo, setReportMergedQueryInfo] =
    useState<BasePagination>({
      ...initialReportQueryInfo,
    });

  useEffect(() => {
    // if (location.state) {
    //   SetHealthStateProps(location.state);
    // }

    const changeParam = new URLSearchParams(location.search);
    if (changeParam.size > 0) {
      setReportQueryInfo((info) => {
        return {
          ...info,
          pageNum: isNull(changeParam.get("pageNum"))
            ? 0
            : Number(changeParam.get("pageNum")),
          pageLimit: isNull(changeParam.get("pageLimit"))
            ? 20
            : Number(changeParam.get("pageLimit")),
          keyword: isNull(changeParam.get("keyword"))
            ? ""
            : (changeParam.get("keyword") as string),
          sortType: isNull(changeParam.get("keyword"))
            ? "name"
            : (changeParam.get("sortType") as string),
          sortDirection: isNull(changeParam.get("sortDirection"))
            ? SORT_DIRECTION.ASC
            : (changeParam.get("sortDirection") as SORT_DIRECTION),
        };
      });
    } else {
      setReportMergedQueryInfo((info) => {
        return {
          ...info,
          pageNum: 0,
          pageLimit: 20,
          keyword: "",
          sortType: "name",
          sortDirection: SORT_DIRECTION.ASC,
        };
      });
    }
  }, [location]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  // const [mergedState, setMergedState] = useState({
  //   mergedSystemId: healthStateProps.mergedSystemId,
  //   mergedSystemName: healthStateProps.mergedSystemName,
  //   reportId: healthStateProps.id,
  // });

  const [reportList, setReportList] = useState<RecorderHealthRow[]>([]);
  const [reportTitle, setReportTitle] = useState<string>("");
  // header 에 있는 상태 표시용 (healthy : healthy + warning / alert: alert + critical + assigned)
  const [totalCount, setTotalCount] = useState<AlertTotalCount>({
    total: 0,
    healthy: 0,
    alert: 0,
    online: 0,
    offline: 0,
  });

  const [alertDetail, setAlertDetail] = useState<AlertDetail>({
    system: 0,
    disk: 0,
    video: 0,
    cloudStatus: false,
  });

  useEffect(() => {}, [location]);

  const onHeaderCell = (column: ColumnType<RecorderHealthRow>) => {
    return {
      onClick: () => {
        if (column.key) {
          setReportQueryInfo((info) => {
            return {
              ...info,
              sortType: column.key as string,
              sortDirection: onSortAntd(info.sortDirection),
              pageNum: 0,
            };
          });
        }
      },
    };
  };

  const onInitial = () => {
    setReportList([]);
    setReportTitle("");
    setTotalCount({
      total: 0,
      healthy: 0,
      alert: 0,
      online: 0,
      offline: 0,
    });
    setAlertDetail({
      system: 0,
      disk: 0,
      video: 0,
      cloudStatus: false,
    });
  };

  // table column
  const columns: TableColumnsType<RecorderHealthRow> = useMemo(
    () => [
      {
        key: "type",
        title: "Title",
        sorter: true,
        sortOrder: changeSortOrderAntd(reportQueryInfo, "name"),
        onHeaderCell: onHeaderCell,
        render: (row) => (
          <Type
            type={convertType(row)}
            licenseType={row.licenseType}
            isCloudCam={row.isCloudCam}
          />
        ),

        defaultSortOrder: "ascend",
        width: isMobile ? 90 : 110,
      },
      {
        key: "name",
        title: "",
        render: (row) => (
          <TableTitle
            row={{
              ...row,
              onlineStatue: checkStatus(
                row.recorderCount || 1,
                row.onlineStatusCount
              ),
            }}
            //onUnderlineClick={onUnderlineClick}
            cloudStatus={alertDetail.cloudStatus}
          />
        ),
      },

      {
        title: "Access",
        render: (value, row, index) => (
          <s.Row
            // className="table-button-wrapper"
            onClick={(e) => e.stopPropagation()}
          >
            <WebAppLink
              {...row}
              accountId={selectedAccount.accountId}
              cloudStatus={alertDetail.cloudStatus}
            />
          </s.Row>
        ),

        responsive: ["lg"],
        hidden:
          selectedAccount.accountLevel !== LEVEL_TYPE.EU ||
          selectedAccount.isHidden,
        width: isMobile ? 120 : "10%",
      },
      {
        key: "accountName",
        title: "Organization",
        render: (row) => {
          if (!row.accountNumber) {
            return;
          }
          return (
            <AccountInfoLabel
              level={LEVEL_TYPE.EU}
              accountNumber={row.accountNumber}
              accountName={row.accountName}
            />
          );
        },
        hidden: selectedAccount.accountLevel === LEVEL_TYPE.EU,
        width: "20%",
      },
      {
        title: "Cameras (Loss / Total)",
        render: (value, row) => (
          <s.CameraRow>
            <s.CameraItem>
              <span className="loss">{formatNumber(row.lossCamera)}</span> /{" "}
              <span className="title">{formatNumber(row.totalCamera)}</span>
            </s.CameraItem>
          </s.CameraRow>
        ),

        responsive: ["lg"],
        width: "20%",
      },
      // 마지막 버튼
      {
        title: "",
        key: "view",
        render: (value, row, index) => (
          <s.Row className="table-button-wrapper row-click-button">
            {row.recorderCount === 1 && (
              <TableButton
                label={"View"}
                onClick={() => onRowClicked(row)}
                data-testid={`reports-view-health-table-button-view-${index}`}
              />
            )}
          </s.Row>
        ),

        align: "right",
        width: isMobile ? 40 : 100,
      },
    ],

    [alertDetail, selectedAccount, reportMergedQueryInfo, reportQueryInfo]
  );
  const onRowClicked = (row: RecorderHealthRow) => {
    if (row.recorderCount > 1) {
      menuNavigation({
        to: `/reports/health/merged/${reportId}/${row.mergedSystemId}`,
      });
    } else {
      menuNavigation({
        to: `/reports/health/detail/${reportId}/${row.recorderId}`,
      });
    }
  };

  const [pending, setPending] = useState<boolean>(true);

  const healthReportQuery = useQuery(
    ["healthList", reportQueryKey, reportId, selectedAccount.accountId],
    () =>
      getHealthReportList({
        payload: reportQueryInfo,
        reportId: reportId as string,
        accountId: selectedAccount.accountId,
      }),
    {
      retry: 0,
      enabled: reportId !== undefined && selectedAccount.accountId !== "",
      onSuccess: (res: any) => {
        if (!res.result || !res.result.healthReports) {
          onInitial();
          setReportQueryInfo({
            ...initialReportQueryInfo,
          });
          return;
        }

        setReportTitle(res.result.title);
        setReportList(
          (res.result.healthReports || []).map(
            (report: ReportHealthList, index: number) => {
              return {
                ...report,
                title: report.mergedSystemName,
                version: report.firmwareVersion,
                status: "status",
                totalStorage: report.storages.reduce(function (
                  prev: any,
                  next: any
                ) {
                  return prev + next.total;
                },
                0),
                freeStorage: report.storages.reduce(function (
                  prev: any,
                  next: any
                ) {
                  return prev + next.free;
                },
                0),
                totalCamera: report.cameraCount,
                lossCamera: report.videoLoss,
                key: index,
              };
            }
          )
        );
        setReportQueryInfo((info) => {
          return {
            ...info,
            ...res.page,
          };
        });

        setTotalCount((info) => {
          return {
            ...info,
            total: res.page.total,
            online: res.result.online,
            offline: res.result.offline,
            alert:
              res.result.systemAlerts +
              res.result.diskAlerts +
              res.result.videoLossAlerts,
          };
        });
        setAlertDetail({
          system: res.result.systemAlerts,
          disk: res.result.diskAlerts,
          video: res.result.videoLossAlerts,
          cloudStatus: res.result.cloudStatus,
        });
      },
      onError: (e: any) => {
        onInitial();
        setReportQueryInfo({
          ...initialReportQueryInfo,
        });
        // notify(
        //   "error",
        //   intl.formatMessage({
        //     id: "label.report.notify.health.list.error",
        //     defaultMessage: "Health search error.",
        //   })
        // );
      },
      onSettled: (e: any) => {
        setPending(false);
      },
    }
  );
  useStompDebouncedRefetch({
    stompKey: ["reportDetailUpdated"] as StompDateSignalKey[],
    refetch: healthReportQuery.refetch,
  });

  const onChangePage = useCallback(
    (page: number, totalRows: number) => {
      console.log(page, totalRows);
      if (page !== reportQueryInfo.pageNum + 1) {
        queryNavigate({
          to: location.pathname,
          queryInfo: {
            pageLimit: reportQueryInfo.pageLimit,
            pageNum: page - 1,
            keyword: reportQueryInfo.keyword as string,
            sortType: reportQueryInfo.sortType,
            sortDirection: reportQueryInfo.sortDirection as SORT_DIRECTION,
          },
        });
        setPending(true);
        // setReportQueryInfo((info) => {
        //   return { ...info, pageNum: page as number };
        // });
      }
    },
    [
      location.pathname,
      queryNavigate,
      reportMergedQueryInfo.keyword,
      reportMergedQueryInfo.pageLimit,
      reportMergedQueryInfo.pageNum,
      reportMergedQueryInfo.sortDirection,
      reportMergedQueryInfo.sortType,
      reportQueryInfo.keyword,
      reportQueryInfo.pageLimit,
      reportQueryInfo.pageNum,
      reportQueryInfo.sortDirection,
      reportQueryInfo.sortType,
    ]
  );

  const onClickSearch = useCallback(
    (keyword: string) => {
      if (reportQueryInfo.keyword !== keyword) {
        queryNavigate({
          to: location.pathname,
          queryInfo: {
            pageLimit: reportQueryInfo.pageLimit,
            pageNum: 0,
            keyword: keyword,
            sortType: reportQueryInfo.sortType,
            sortDirection: reportQueryInfo.sortDirection as SORT_DIRECTION,
          },
        });
      } else {
        healthReportQuery.refetch();
      }
      setPending(true);
    },
    [
      healthReportQuery,
      location.pathname,
      queryNavigate,
      reportMergedQueryInfo.keyword,
      reportMergedQueryInfo.pageLimit,
      reportMergedQueryInfo.sortDirection,
      reportMergedQueryInfo.sortType,
      reportQueryInfo.keyword,
      reportQueryInfo.pageLimit,
      reportQueryInfo.sortDirection,
      reportQueryInfo.sortType,
    ]
  );

  const col: TableColumnsType<RecorderHealthRow> = useMemo(() => {
    if (selectedAccount.accountLevel === LEVEL_TYPE.EU) {
      return columns.filter((col) => col.key !== "accountName");
    }
    return columns;
  }, [selectedAccount, columns]);

  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);

  const expandableProps = useMemo<ExpandableConfig<RecorderHealthRow>>(() => {
    return {
      expandRowByClick: true,
      expandedRowKeys,
      onExpand: (expanded: boolean, row: RecorderHealthRow) => {
        if (expanded) {
          setExpandedRowKeys([row.mergedSystemId]);
        } else {
          setExpandedRowKeys([]);
        }
      },
      expandedRowRender: (row: RecorderHealthRow) => (
        <HealthExpandContainer
          mergedSystemId={row.mergedSystemId}
          queryKey={reportQueryInfo}
          columns={columns}
          onRowClick={onRowClicked}
          reportId={reportId}
        />
      ),

      rowExpandable: (row: RecorderHealthRow) => row.recorderCount > 1,
    };
  }, [columns, expandedRowKeys, reportId]);
  if (healthReportQuery.error) {
    return (
      <NoAvailable
        onReturn={() => menuNavigation({ to: "/reports" })}
        buttonLabel="Return to Reports"
        message="This report is no longer available"
      />
    );
  }
  return (
    <HealthPresenter
      selectedAccount={selectedAccount}
      title={reportTitle}
      columns={col}
      data={reportList}
      // mergedState={mergedState}
      reportId={reportId}
      totalCount={totalCount}
      alertDetail={alertDetail}
      onRowClicked={onRowClicked}
      onChangePage={onChangePage}
      onClickSearch={onClickSearch}
      paginationInfo={reportQueryInfo}
      tablePending={pending}
      expandableProps={expandableProps}
      activeExpandRow={expandedRowKeys[0]}
    />
  );
}
